import React from "react";
import { format, startOfMonth, getDay, getDaysInMonth } from "date-fns";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const Calendar: React.FC = () => {
  const today = new Date();
  const monthStart = startOfMonth(today);
  const month = format(today, "MMMM yyyy");
  const currentDate = today.getDate();
  const daysInMonth = getDaysInMonth(today);

  const startDay = getDay(monthStart); // Sunday = 0
  const weekDays = ["S", "M", "T", "W", "T", "F", "S"];
  const eventDays = [5, 12, 18]; // sample event days

  return (
    <div className="bg-white rounded-lg shadow-inner lg:p-4 w-full  mx-auto border border-gray-200">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        {/* Left empty space (for potential future elements) */}
        <div className="w-0"></div>

        {/* Centered month text */}
        <h3 className="text-xl font-semibold text-gray-800 text-center flex-grow">
          {month}
        </h3>

        {/* Right empty space (for potential future elements) */}
        <div className="w-0"></div>
      </div>

      {/* Week Days */}
      <div className="grid grid-cols-7 text-center text-sm font-medium text-gray-500 mb-2">
        {weekDays.map((day, idx) => (
          <div key={idx}>{day}</div>
        ))}
      </div>

      {/* Calendar Days */}
      <div className="grid grid-cols-7 text-center gap-y-1 text-sm">
        {Array.from({ length: startDay }).map((_, i) => (
          <div key={`empty-${i}`} className="py-2"></div>
        ))}
        {Array.from({ length: daysInMonth }).map((_, i) => {
          const day = i + 1;
          const isToday = day === currentDate;
          const hasEvent = eventDays.includes(day);

          return (
            <div
              key={day}
              className={`relative py-2 w-8 h-8 mx-auto flex items-center justify-center rounded-full transition-all duration-200
                ${
                  isToday
                    ? "bg-emerald-500 text-white"
                    : "text-gray-700 hover:bg-gray-100"
                }
              `}
            >
              {day}
            </div>
          );
        })}
      </div>
    </div>
  );
};
